module.exports = __webpack_public_path__ + "static/welcome-image-compressed-0cd4c1eda75378c27eae8443e7398b4c.png";